import { useResource } from '@landsbankinn/l16n';
import { theme } from '@landsbankinn/ui';
import React from 'react';
import { MarketsSelectorTabs } from '../../shared/MarketsComponents';
import { FundDataType } from '../Funds';
import res from '../Funds.res';
import type {
  AnnualizedReturnOptions,
  NominalReturnOptions,
} from './useReturnsConfig';
import {
  useAnnualizedReturnsOptions,
  useNominalReturnsOptions,
} from './useReturnsConfig';

interface IProps {
  fundDataType: FundDataType;
  initialNominalReturn: NominalReturnOptions;
  initialAnnualizedReturn: AnnualizedReturnOptions;
  onSelectNominalReturn: (id: NominalReturnOptions) => void;
  onSelectAnnualizedReturn: (id: AnnualizedReturnOptions) => void;
}

export function ReturnsSelectorTab({
  fundDataType,
  initialNominalReturn,
  initialAnnualizedReturn,
  onSelectNominalReturn,
  onSelectAnnualizedReturn,
}: IProps) {
  const { r } = useResource();

  const nominalReturnsConfig = useNominalReturnsOptions();
  const annualizedReturnsConfig = useAnnualizedReturnsOptions();

  const [selectedNominalReturn, setSelectedNominalReturn] =
    React.useState(initialNominalReturn);
  const [selectedAnnualizedReturn, setSelectedAnnualizedReturn] =
    React.useState(initialAnnualizedReturn);

  function selectReturn(val: any) {
    if (fundDataType === FundDataType.NominalReturn) {
      setSelectedNominalReturn(val);
      onSelectNominalReturn(val);
    } else if (fundDataType === FundDataType.AnnualizedReturn) {
      setSelectedAnnualizedReturn(val);
      onSelectAnnualizedReturn(val);
    }
  }

  return (
    <>
      {fundDataType === FundDataType.NominalReturn && (
        <MarketsSelectorTabs
          mobileLabel={r(res.selectInformation)}
          mobileInset
          onSelectTab={(val) => {
            selectReturn(Number(val));
          }}
          selectedItemId={selectedNominalReturn.toString()}
          items={nominalReturnsConfig}
          color={theme.colors.secondary}
        />
      )}
      {fundDataType === FundDataType.AnnualizedReturn && (
        <MarketsSelectorTabs
          mobileLabel={r(res.selectInformation)}
          mobileInset
          onSelectTab={(val) => {
            selectReturn(Number(val));
          }}
          selectedItemId={selectedAnnualizedReturn.toString()}
          items={annualizedReturnsConfig}
          color={theme.colors.secondary}
        />
      )}
    </>
  );
}
